import React from "react";

import "./Footer.style.scss";

import Clock from "../components/Clock";

const Footer = () => {
  return (
    <>
      <div className='footer'>
        <p>Justin Nguyen {new Date().getFullYear() }</p>
        <ul>
          <a
            className='link'
            href='https://github.com/nuggetnchill'
            target='_blank'
            rel='noopener noreferrer'
          >
            Github
          </a>
          <a
            className='link'
            href='https://twitter.com/nuggetnchill'
            target='_blank'
            rel='noopener noreferrer'
          >
            Twitter
          </a>
        </ul>
      </div>
      <Clock />
    </>
  );
};

export default Footer;
